<div>
    <h2>Input</h2>
    <div class="flex flex-col space-y-6">
      <div class="flex flex-col">
          <label class="label">Text Input</label>
          <input type="text" class="text-lg input-text">
      </div>
      <div class="">
        <input type="checkbox" class="input-checkbox">
        <label class="mx-1 label">Checkbox</label>
      </div>
      <div class="flex flex-col">
        <label class="mx-1 label">Upload a file</label>
        <input type="file" class="px-4 py-4 text-lg">
      </div>
      
    </div>
</div>
